// extracted by mini-css-extract-plugin
export var active = "_lb-2";
export var recordingDot = "_lb-1";
export var recordingIndicator = "_lb-0";